// Klasser som motsvarar diton i C#:




/*


 Obs! Dessa måste överensstämma *exakt* med resultatet av en konvertering av motsvarande C#-klasser till Json!!!
 Bl.a. att de har inledande versaler på proparna (C# naming convention).






*/






//###################################################################################################

// En metod att få "enum" i JavaScript:

const AnvandareTypEnum = Object.freeze({
	// Undviker 0 pga javascripts lössläppta hantering av == och !=:
	LICENS: 1,
	FORETAG: 2,
	SUPPORTPERSON: 3,

	INTEVALD: 999
});




//###################################################################################################

class AnvandareFormModelClass
{
	constructor(
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			licenseId = undefined,
			foretagId = undefined,
			personId = undefined,

			anvandartyp = undefined,

			namn = undefined,
			telefon = undefined,
			epost = undefined,

			sakerhetskodFor2FAKravs = undefined,

			powerUser = undefined,		// undef krävs här om man ska kunna typkontrollera att boolean (och t.ex. inte undef). Was: false,
			// Utgått enl spec: superUser = false,
			administrator = undefined,		// undef krävs här om man ska kunna typkontrollera att boolean (och t.ex. inte undef). Was: false,
			lockedDown = undefined,		// undef krävs här om man ska kunna typkontrollera att boolean (och t.ex. inte undef). Was: false,

			licensForetagPersonForandringsskydd = undefined,
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(!licenseId || typeof licenseId === 'string',
			'Parametern \'licenseId\' måste vara av typen \'string\' (eller null/undefined).');

		console.assert(!foretagId || typeof foretagId === 'string',
			'Parametern \'foretagId\' måste vara av typen \'string\' (eller null/undefined).');

		console.assert(!personId || typeof personId === 'string',
			'Parametern \'personId\' måste vara av typen \'string\' (eller null/undefined).');


		// Hmm.. denna ska väl vara en int (enum) eller undef? Ändrar:
		//console.assert(!anvandartyp || anvandartyp === 'string',
		//	'Parametern \'anvandartyp\' måste vara av typen \'string\' (eller null/undefined).');
		console.assert(!anvandartyp || Number.isInteger(anvandartyp),
			'Parametern \'anvandartyp\' måste vara ett heltal (enum) (eller null/undefined).');


		console.assert(!namn || typeof namn === 'string',
			'Parametern \'namn\' måste vara av typen \'string\' (eller null/undefined).');

		console.assert(!telefon || typeof telefon === 'string',
			'Parametern \'telefon\' måste vara av typen \'string\' (eller null/undefined).');

		console.assert(!epost || typeof epost === 'string',
			'Parametern \'epost\' måste vara av typen \'string\' (eller null/undefined).');


		console.assert(typeof sakerhetskodFor2FAKravs === 'boolean',
			'Parametern \'sakerhetskodFor2FAKravs\' är obligatorisk och måste vara en boolean.');


		console.assert(typeof powerUser === 'boolean',
			'Parametern \'powerUser\' är obligatorisk och måste vara en boolean.');

		// Utgått enl spec:
		//console.assert(typeof superUser === 'boolean',
		//	'Parametern \'superUser\' är obligatorisk och måste vara en boolean.');

		console.assert(typeof administrator === 'boolean',
			'Parametern \'administrator\' är obligatorisk och måste vara en boolean.');

		console.assert(typeof lockedDown === 'boolean',
			'Parametern \'lockedDown\' är obligatorisk och måste vara en boolean.');


		console.assert(!licensForetagPersonForandringsskydd || typeof licensForetagPersonForandringsskydd === 'string',
			'Parametern \'licensForetagPersonForandringsskydd\' måste vara av typen \'string\' (eller null/undefined).');

		// ---------------------------------------------------------------------------

		this.LicenseId = licenseId;
		this.ForetagId = foretagId;
		this.PersonId = personId;

		this.Anvandartyp = anvandartyp;

		//[Required(ErrorMessage = "Måste fyllas i.")]
		//[MaxLength(250, ErrorMessage = "Högst 250 tecken")]
		this.Namn = namn;

		//[Required(ErrorMessage = "Måste fyllas i.")]
		//[MaxLength(250, ErrorMessage = "Högst 250 tecken")]
		this.Telefon = telefon;

		//[Required(ErrorMessage = "Måste fyllas i.")]
		//[EmailAddress]
		//[MaxLength(250, ErrorMessage = "Högst 250 tecken")]
		this.Epost = epost;

		this.SakerhetskodFor2FAKravs = sakerhetskodFor2FAKravs;

		this.PowerUser = powerUser;
		// Utgått enl spec: this.SuperUser = superUser;
		this.Administrator = administrator;
		this.LockedDown = lockedDown;

		this.LicenseForetagPersonForandringsskydd = licensForetagPersonForandringsskydd;
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen AnvandareFormModelClass):
	// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden (för sådana förekommer inte i denna class).
	static castFrom(obj)
	{
		// Obs! Bytt till säkrare sätt så att:
		// 1. Kontroll sker att indata (parametern obj) har de members som den ska och
		// 2. Constructorns "basic typkontroller" av parametrar appliceras på dessa indata.
		//
		//let ny = new AnvandareFormModelClass();
		//ny = Object.assign(ny, obj);

		const tomt = new AnvandareFormModelClass({
			powerUser: false,
			administrator: false,
			lockedDown: false,

		});

		for (const propertyName in tomt)
		{
			//console.log(`tomt.${propertyName}`);
			console.assert(propertyName in obj, `Objektet som ska "castas" saknar den obligatoriska membern '${propertyName}'.`, obj);
		}

		for (const propertyName in obj)
		{
			//console.log(`obj.${propertyName}`);
			console.assert(propertyName in tomt, `Objektet som ska "castas" har en member som inte får finnas ('${propertyName}').`, obj);
		}

		// Använd constructorn för att få ""basic typkontroller":
		let ny = new AnvandareFormModelClass({
			licenseId: obj.LicenseId,
			foretagId: obj.ForetagId,
			personId: obj.PersonId,

			anvandartyp: obj.Anvandartyp,

			namn: obj.Namn,
			telefon: obj.Telefon,
			epost: obj.Epost,

			sakerhetskodFor2FAKravs: obj.SakerhetskodFor2FAKravs,

			powerUser: obj.PowerUser,
			administrator: obj.Administrator,
			lockedDown: obj.LockedDown,

			licensForetagPersonForandringsskydd: obj.LicenseForetagPersonForandringsskydd,
		});

		return ny;
	}

	// ==========================================================

	get ArAnvandartypLicens() {
		return (!!this.Anvandartyp && this.Anvandartyp === AnvandareTypEnum.LICENS);
	}

	get ArAnvandartypForetag() {
		return (!!this.Anvandartyp && this.Anvandartyp === AnvandareTypEnum.FORETAG);
	}
}


export default {
	AnvandareTypEnum: AnvandareTypEnum,
	AnvandareFormModel: AnvandareFormModelClass,
};

export { AnvandareTypEnum };
export { AnvandareFormModelClass as AnvandareFormModel };

